/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Category } from '../models/category';
import { DataPageOfDocument } from '../models/data-page-of-document';
import { documentCatList } from '../fn/document/document-cat-list';
import { DocumentCatList$Params } from '../fn/document/document-cat-list';
import { documentDetail } from '../fn/document/document-detail';
import { DocumentDetail$Params } from '../fn/document/document-detail';
import { documentGetcategorylistbypatient } from '../fn/document/document-getcategorylistbypatient';
import { DocumentGetcategorylistbypatient$Params } from '../fn/document/document-getcategorylistbypatient';
import { documentGetDocuments } from '../fn/document/document-get-documents';
import { DocumentGetDocuments$Params } from '../fn/document/document-get-documents';
import { documentIsS3ConnectionSuccessful } from '../fn/document/document-is-s-3-connection-successful';
import { DocumentIsS3ConnectionSuccessful$Params } from '../fn/document/document-is-s-3-connection-successful';
import { documentList } from '../fn/document/document-list';
import { DocumentList$Params } from '../fn/document/document-list';
import { DocumentModels } from '../models/document-models';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentList()` */
  static readonly DocumentListPath = '/document/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentList$Response(params?: DocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfDocument>> {
    return documentList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentList(params?: DocumentList$Params, context?: HttpContext): Observable<DataPageOfDocument> {
    return this.documentList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfDocument>): DataPageOfDocument => r.body)
    );
  }

  /** Path part for operation `documentGetcategorylistbypatient()` */
  static readonly DocumentGetcategorylistbypatientPath = '/document/getcategorylistbypatient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetcategorylistbypatient()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetcategorylistbypatient$Response(params?: DocumentGetcategorylistbypatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Category>>> {
    return documentGetcategorylistbypatient(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetcategorylistbypatient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetcategorylistbypatient(params?: DocumentGetcategorylistbypatient$Params, context?: HttpContext): Observable<Array<Category>> {
    return this.documentGetcategorylistbypatient$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Category>>): Array<Category> => r.body)
    );
  }

  /** Path part for operation `documentCatList()` */
  static readonly DocumentCatListPath = '/documentcat/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentCatList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentCatList$Response(params?: DocumentCatList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfDocument>> {
    return documentCatList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentCatList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentCatList(params?: DocumentCatList$Params, context?: HttpContext): Observable<DataPageOfDocument> {
    return this.documentCatList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfDocument>): DataPageOfDocument => r.body)
    );
  }

  /** Path part for operation `documentDetail()` */
  static readonly DocumentDetailPath = '/document/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentDetail$Response(params?: DocumentDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentModels>> {
    return documentDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentDetail(params?: DocumentDetail$Params, context?: HttpContext): Observable<DocumentModels> {
    return this.documentDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentModels>): DocumentModels => r.body)
    );
  }

  /** Path part for operation `documentGetDocuments()` */
  static readonly DocumentGetDocumentsPath = '/document/getDocuments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocuments$Response(params?: DocumentGetDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return documentGetDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocuments(params?: DocumentGetDocuments$Params, context?: HttpContext): Observable<Blob> {
    return this.documentGetDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `documentIsS3ConnectionSuccessful()` */
  static readonly DocumentIsS3ConnectionSuccessfulPath = '/api/Document/isS3ConnectionSuccess';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentIsS3ConnectionSuccessful()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentIsS3ConnectionSuccessful$Response(params: DocumentIsS3ConnectionSuccessful$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return documentIsS3ConnectionSuccessful(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentIsS3ConnectionSuccessful$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentIsS3ConnectionSuccessful(params: DocumentIsS3ConnectionSuccessful$Params, context?: HttpContext): Observable<boolean> {
    return this.documentIsS3ConnectionSuccessful$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
